<template>
  <div class="swhyjm">
    <!-- header -->
    <div class="swhyjm-header">
      <img src="../assets/img/banner.png" class="banner-img" />
      <div class="swhyjm-header-tab-container" id="tabBarContainer">
        <div
          :class="['swhyjm-header-tab', isFixed ? 'swhyjm-header-fixed' : '']"
        >
          <div class="tab-list">
            <div
              :class="['tab-item', index === tabIndex ? 'active' : '', tab.children ? 'tab-item-select': '']"
              v-for="(tab, index) in tabs"
              :key="index"
              @click="handleTap(index, tab.key)"
            >
              {{ tab.text }}
              <div v-if="tab.children && tab.children.length" class="tab-item-drop">
                <div class="drop-item" v-for="(item, index) in tab.children" :key="index" @click.stop="gotoCsmar(item)">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="swhyjm-content">
      <Csmar v-show="showKey === 'Csmar'"/>
      <Introduction v-show="showKey === 'Introduction'" />
      <Rule v-show="showKey === 'Rule'" />
      <Award v-show="showKey === 'Award'" />
      <Rank v-if="showKey === 'Rank'" />
      <Report v-if="showKey === 'Report'" />
    </div>
    <!-- footer -->
    <div class="swhyjm-footer">
      <img
        src="../assets/img/apply-icon.png"
        class="apply-icon"
        style=""
        v-show="isFixed"
        @click="handleJump"
      />
      <img
        src="../assets/img/dow.png"
        class="to-top-icon"
        style=""
        v-show="isFixed"
        @click="handleGoTop"
      />
      <div class="swhyjm-footer-container">
        <div class="swhyjm-footer-container-organizer">
          <span>主办单位：</span>
          <img src="../assets/img/organizer.png" />
        </div>
        <div class="swhyjm-footer-container-ppw">
          <span>承办单位：</span>
          <img src="../assets/img/ppw-logo.png" />
        </div>
        <div class="swhyjm-footer-container-tips">
          投资有风险<br />选择需谨慎
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Csmar from "@/components/Csmar";
import Introduction from "@/components/Introduction";
import Rule from "@/components/Rule";
import Award from "@/components/Award";
import Rank from "@/components/Rank";
import Report from "@/components/Report";
export default {
  name: "App",
  components: {
    Csmar,
    Introduction,
    Rule,
    Award,
    Rank,
    Report,
  },
  data() {
    return {
      showKey: "Csmar",
      tabIndex: 0,
      tabs: [
        {
          key: "Csmar",
          text: "希施玛特色产品服务",
          children: [
            {
              text: '红楹量化数据库',
              href: 'http://testsite.csmar.com:5110/channels/36.html#quantifica'
            },
            {
              // text: '希施玛Level-2实时行情接口服务',
              text: 'Level-2实时行情接口',
              href: 'http://testsite.csmar.com:5110/channels/36.html#level'
            },
            {
              text: '红楹金融终端',
              href: 'http://testsite.csmar.com:5110/channels/35.html'
            },
            {
              text: '红楹金玛终端',
              href: 'http://testsite.csmar.com:5110/channels/37.html'
            },
          ]
        },
        {
          key: "Introduction",
          text: "大赛简介",
        },
        {
          key: "Rule",
          text: "赛事规则",
        },
        {
          key: "Award",
          text: "权益奖励",
        },
        {
          key: "apply",
          text: "报名申请",
        },
        {
          key: "Rank",
          text: "大赛排名",
        },
        {
          key: "Report",
          text: "赛事报道",
        },
      ],
      isFixed: false,
    };
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 滚动吸顶
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector("#tabBarContainer").offsetTop;
      if (scrollTop > offsetTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    // 导航栏切换
    handleTap(index, key) {
      if (index === 4) {
        this.handleJump();
      } else {
        // 暂时取消跳转页面
        // if (index == 0) {
        //   var routeData = this.$router.resolve({
        //     path: '/csmarpage'
        //   })
        //   window.open(routeData.href, '_blank');
        //   return
        // }
        this.tabIndex = index;
        if (key) {
          this.showKey = key;
          var offsetTop = document.querySelector("#tabBarContainer").offsetTop;
          setTimeout(() => {
            window.scrollTo(0, offsetTop);
          }, 0)
        }
      }
    },
    // 跳转官网
    gotoCsmar(item) {
      window.open(
        item.href
      )
    },
    // 跳转报名
    handleJump() {
      window.open(
        "https://activity.simuwang.com/pc/dist/competition/swhyjm-2021/index.html?channel=xsm&tab=apply"
      );
    },
    // 返回顶部
    handleGoTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      const timeTop = setInterval(() => {
        document.body.scrollTop =
        document.documentElement.scrollTop = top -= 150;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 25);
    },
  },
};
</script>


<style lang="less">
// @import url("../style/index.css");
.swhyjm {
  width: 100%;
  height: 100%;
  background-color: #0d0a85;
}
.swhyjm-header {
  .banner-img {
    display: block;
    width: 100%;
    vertical-align: baseline;
  }
  .swhyjm-header-tab-container {
    width: 100%;
    height: 50px;
  }
  .swhyjm-header-tab {
    position: static;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 50px;
    background: #b38a1f;
    .tab-list {
      position: relative;
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      display: -webkit-box;
      display: -ms-flexbox;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -200px;
        display: block;
        width: 200px;
        height: 50px;
        background: url("../assets/img/tab-bg.png") no-repeat center / 100% 100%;
      }
      .tab-item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        // width: 171.6px;
        width: 171.6px;
        height: 100%;
        font-size: 17px;
        // font-weight: 400;
        color: #fff;
        cursor: pointer;
        background: url("../assets/img/tab-bg.png") no-repeat center / 100% 100%;
        -webkit-transition: all 0.38s;
        transition: all 0.38s;
        &.tab-item-select {
          position: relative;
          letter-spacing: 0px;
          &:hover .tab-item-drop{
            display: block;
            border: none;
            border-right: 1px solid transparent;
            border-left: 1px solid transparent;
            border-bottom: 1px solid transparent;
            background: #fff;
          }
        }
      }
      .active {
        background: #fff;
        color: #07117c;
        font-weight: bold;
      }
      .tab-item-drop {
        display: none;
        position: absolute;
        top: 50px;
        left: 0;
        width: 270px;
        background: transparent;
        border: none;
        border-right: 1px solid transparent;
        border-left: 1px solid transparent;
        border-bottom: 1px solid transparent;
        z-index: 1000;
        .drop-item {
          color: #333;
          font-weight: normal;
          font-size: 16px;
          padding: 15px 8px;
          border: none;
          border-right: 1px solid transparent;
          border-left: 1px solid transparent;
          border-bottom: 1px solid transparent;
          &:hover {
            border: none;
            border-right: 1px solid transparent;
            border-left: 1px solid transparent;
            border-bottom: 1px solid transparent;
            color: #07117c;
          }
        }
      }
    }
    &.swhyjm-header-fixed {
      position: fixed;
    }
  }
}
.swhyjm-footer {
  width: 100%;
  height: 103px;
  background: #00084f;
  .apply-icon {
    position: fixed;
    z-index: 90;
    right: 57px;
    bottom: 250px;
    width: 142px;
    height: 142px;
    cursor: pointer;
  }
  .to-top-icon {
    position: fixed;
    z-index: 90;
    right: 105px;
    bottom: 118px;
    width: 45px;
    height: 45px;
    cursor: pointer;
  }
  .swhyjm-footer-container {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .swhyjm-footer-container-organizer {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.7);
      img {
        width: 518px;
        height: 48px;
      }
    }
    .swhyjm-footer-container-ppw {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.7);
      img {
        width: 125px;
        height: 35px;
      }
    }
    .swhyjm-footer-container-tips {
      width: 136px;
      height: 57px;
      border: 1px solid rgba(255, 255, 255, 0.7);
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      line-height: 22px;
      padding-top: 6px;
    }
  }
}
</style>
<style lang="less">
@media screen and (max-width: 1200px) {
  .swhyjm {
    width: 1400px !important;
    height: 100% !important;
    background-color: #0d0a85;
  }
}
</style>
